"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Button_1 = __importDefault(require("./Button"));
const Checkbox_1 = __importDefault(require("./Checkbox"));
const Currency_1 = __importDefault(require("./Currency"));
const Date_1 = __importDefault(require("./Date"));
const DateRange_1 = __importDefault(require("./DateRange"));
const Fallback_1 = __importDefault(require("./Fallback"));
const FieldError_1 = __importDefault(require("./FieldError"));
const Input_1 = __importDefault(require("./Input"));
const InputMetaWrapper_1 = __importDefault(require("./InputMetaWrapper"));
const Output_1 = __importDefault(require("./Output"));
const Select_1 = __importDefault(require("./Select"));
const wrapped = {
    select: (0, InputMetaWrapper_1.default)(Select_1.default),
    number: (0, InputMetaWrapper_1.default)((0, Input_1.default)('number')),
};
const defaults = {
    enum: wrapped.select,
    'enum-multiple': wrapped.select,
    string: (0, InputMetaWrapper_1.default)((0, Input_1.default)('text')),
    currency: (0, InputMetaWrapper_1.default)(Currency_1.default),
    number: wrapped.number,
    zipcode: wrapped.number,
    integer: wrapped.number,
    email: (0, InputMetaWrapper_1.default)((0, Input_1.default)('email')),
    phone: (0, InputMetaWrapper_1.default)((0, Input_1.default)('phone')),
    url: (0, InputMetaWrapper_1.default)((0, Input_1.default)('url')),
    date: (0, InputMetaWrapper_1.default)(Date_1.default),
    range: (0, InputMetaWrapper_1.default)(DateRange_1.default),
    boolean: (0, InputMetaWrapper_1.default)(Checkbox_1.default),
    button: Button_1.default,
    submit: Button_1.default,
    output: (0, InputMetaWrapper_1.default)(Output_1.default),
    error: FieldError_1.default,
    fallback: Fallback_1.default,
};
exports.default = defaults;
//# sourceMappingURL=default-renderers.js.map